<template src="./html/Create.html"></template>

<script>
	import Multiselect from 'vue-multiselect'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import DepartmentModal from './../../../departments/views/Modal.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
			'department-modal': DepartmentModal,
		},
		data () {
			return {
				modal: {
					selector: 'create-team',
				},

				item: {
					name: null,
					description: null,
					users: [],
				},

				options: [],
				isLoading: false,

				department: null,
				departments: null,
				newUser: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getDepartments()
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			addUser() {
				if(this.newUser) {
					this.item.users.push(this.newUser)
					let index = this.department.users.indexOf(this.newUser)
					this.department.users.splice(index, 1)
					this.newUser = null
				}
			},
			quitUser(user) {
				let index = this.item.users.indexOf(user)
				this.item.users.splice(index, 1)
			},
			getDepartments() {
				this.$http.get('admin/departments')
				.then(response => {
					this.departments = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			clearData() {
				this.item.name = null;
				this.item.description = null;
				this.item.users = null;
			},
			store() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				this.$http.post('admin/projects/teams', this.item)
				.then(response => {
					this.$emit('reload')
					loading.stop()
					this.clearData()
					var that = this
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					}).then(function () {
						that.close()
					})
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
			openPopoverDate(id) {
				var popover = $('#popover-'+id)
				popover.popover('toggle')
			},
			dateUnavailable (unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return start.format('DD/MM/YYYY - H:mm') + ' | ' + end.format('DD/MM/YYYY - H:mm')
						}
					}
				}
			},
			typeUnavailable(unavailable) {
				if(unavailable.length) {
					for (var i = 0; i < unavailable.length; i++) {
						var element = unavailable[i]
						var start = moment(element.start_date)
						var end = moment(element.end_date)
						if(moment().isBetween(start, end)) {
							return element.type
						}
					}
				}
			},
			search(query) {
				if(query) {
					this.isLoading = true
					var data = {
						query: query,
						filter: {
							department_id: null,
							team_id: null,
						}
					}

					if(this.item.project) {
						data.filter.team_id = this.item.project.team_id
					}

					if(this.department) {
						data.filter.department_id = this.department.id
					}

					this.$http.post('admin/users/search', data)
					.then(response => {
						this.isLoading = false
						this.options = response.body
					}).catch(function(response) {
						this.isLoading = false
						console.log(response)
					})
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/teams/views/Create.vue